import { useElement, useLocale, useService } from "../../../hooks";

export const Thankyou = () => {
  const { t } = useLocale();
  const Img = useElement("Img");
  const Button = useElement("Button");
  const { setTitle } = useService("Meta");
  setTitle(t("thankYou"));
  return (
    <div className="body-background flex">
      <div className="container">
        <div className="form-box-setup thankyou-page">
          <div className="form-box">
            <Img
              alt={t("thankYou")}
              source="internal"
              src={require("../../../../assets/images/thankyou.png")}
            />
            <div id="content-box" className="content">
              <h1 className="title">
                <span>{t("data.thankYouTitle")}</span>
              </h1>
              <p>{t("data.thankYouDescription")}</p>
            </div>
            <Button className="btn btn-primary mv30">{t("okay")}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
